import { Typography, Button, Box } from '@material-ui/core';
import React, { memo } from 'react';

import styles from './styles';

interface IProps {
  classes: any;
}

const CheckoutBumpHelperText = ({ classes }: IProps) => {
  return (
    <>
      <Box className={classes.container}>
        <img src='/img/logo-checkout.svg' alt='Checkout Sun Logo' className={classes.sunLogo} />
        <Typography className={classes.helperText} component='p'>
          Aumente sua conversão adicionando mais funcionalidades à sua página de checkout.
        </Typography>
      </Box>
      <Box className={classes.cardContainer}>
        <Box className={classes.cardHeader}>
          <img src='/img/order-bump.svg' alt='Order Bump Icon' />
          <Typography className={classes.cardTitle}>Order Bump</Typography>
        </Box>
        <Typography className={classes.informative} component='p'>
          Crie ofertas adicionais dentro do checkout do seu produto para aumentar seu ticket-médio
        </Typography>
        <Button
          onClick={() =>
            window.open('https://sun-admin.eduzz.com/orderbump/?utm_source=Orbita&utm_medium=Cadastro+b%C3%A1sico+&utm_campaign=Orderbump', '_blank')
          }
          color='primary'
          variant='text'
          className={classes.button}
        >
          Adicionar
        </Button>
      </Box>
    </>
  );
};

export default styles(memo(CheckoutBumpHelperText));
